<script>
	// Stores
	import { 
		linkMapa,
		linkWaze,
		linkUber,
		linkAV, 
		linkAPI, 
		tagsSEO, 
		textEndereco, 
		textAtendimento, 
		textCNPJ, 
		textCreci, 
		textSite, 
		todosContatos, 
		linkFacebook,
		linkInstagram,
		linkTwitter,
		linkYoutube,
		linkWhatsappVendas,
		linkWhatsappLocacao,
		linkPoliticaPrivacidade,
		linkPoliticaCookies,
		linkTermoLGPD
	} from '../store.js';

	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";
	

	let localizacao = [
		{
			title: 'Mapa',
			icon: '<i class="fas fa-2x fa-map-marked-alt"></i>',
			link: $linkMapa,
		},
		{
			title: 'Waze',
			icon: '<i class="fab fa-2x fa-waze"></i>',
			link: $linkWaze,
		},
		{
			title: 'Uber',
			icon: '<i class="fab fa-2x fa-uber"></i>',
			link: $linkUber,
		},
	];
</script>

<footer>
	<section class="informacoes">
		<div class="container">
			<div class="flex sm-flex-column sm-flex-center">
				<div class="flex-1 sm-flex-center gap-10 mb-30 mt-10">
					<div class="flex sm-flex-center">
						<img src="/assets/images/logoFooter.png" border="0" alt="Logotipo" />
					</div>
					<div class="flex sm-flex-center mt-20 text-smaller">
						CRECI {$textCreci} - CNPJ {$textCNPJ}
					</div>
					<div class="flex flex-1 flex-left mt-20 gap-10 sm-flex-center text-title">
						<a href={$linkFacebook} target="_blank"><i class="fab fa-facebook-square"></i></a>
						<a href={$linkInstagram} target="_blank"><i class="fab fa-instagram"></i></a>
						<a href={$linkTwitter} target="_blank"><i class="fab fa-twitter"></i></a>
						<a class="hide" href={$linkWhatsappVendas}><i class="fab fa-whatsapp"></i></a>
					</div>					
					<div class="flex sm-flex-center mt-20">
						<a target="_blank" href="https://reempregars.com.br/">
							<img src="/assets/images/logoReemprega.png" width="100px" border="0" alt="ReempregaRS">
						</a>
					</div>
				</div>
				<div class="flex-1 flex-center sm-flex-center gap-10 text-title">
					<div class="text-center mb-30">
						<i class="fal fa-phone-alt"></i>
						<a class="text-bold" href="tel://5133964466">51 3396.4466</a>
						<div class="mt-10 text-smaller">
							<b>Condomínio, Locação e Vendas</b>
							<br />
							MATRIZ
							<br />
							Rua Múcio Teixeira, 129,<br />Menino Deus,<br />Porto Alegre, RS.
						</div>
					</div>
				</div>
				<div class="flex-1 flex-center sm-flex-center gap-10 text-title">
					<div class="text-center mb-30">
						<i class="fal fa-phone-alt"></i>
						<a class="text-bold" href="tel://5132730097">51 3273.0097</a>
						<div class="mt-10 text-smaller">
							<b>Locação e Vendas</b>
							<br />
							FILIAL
							<br />
							Av. Getúlio Vargas, 1596, loja 01,<br />Menino Deus,<br />Porto Alegre, RS.
						</div>
					</div>
				</div>				
				<div class="flex-1 flex flex-column gap-10 text-right sm-flex-center pb-10">
					<a class="text-bold" href={$linkPoliticaPrivacidade} target="_blank">Política de Privacidade</a>
					<a class="text-bold" href={$linkPoliticaCookies} target="_blank">Política de Cookies</a>
					<div>
						<a target="_blank" href={$linkTermoLGPD}>
							<img src="/assets/images/logoLGPD.png" border="0" alt="LGPD" width="180px" />
						</a>
					</div>					
					<p class="mt-20 text-smaller">
						<copy>Desenvolvido por <a href="{$linkAPI}" target="_blank" title="API - Tecnologia digital resultados reais">API</a> e <a href="https://www.agenciaff.com.br/" target="_blank" title="FF Comunicação">Agência FF</a></copy>
					</p>					
				</div>
			</div>
		</div>
	</section>
</footer>